import MatchPhaseProvider from './matchPhaseProvider';

export function getPeriodInfo(match, gridLocalization) {
    const sportId = match.get("realSportId");
    const periodId = match.getIn(["period", "id"]);
    const matchPhase = MatchPhaseProvider.getMatchPhase(sportId, periodId);

    return {
        matchMinute: match.getIn(["period", "minute"]),
        period: gridLocalization.getPeriodName(sportId, periodId),
        matchPhase
    }
}


// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/sportGlossary/utils.js